import React, { useState, useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import "../../../styles/csv_upload.css";
import label from "../../labels/postExaminationProcessObjective_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import { toastr } from 'react-redux-toastr';

import {
    getAdvertisementsList,
    getExamslistByAdvertisementId,
    getSubjectlistByExamId,
    getDownloadAnswerKeyDataBySubjectId,
    updateAnswerKeyData,
    getAllApprovalAnswerKeyListPagination,
    getExaminersAndModeratorReportData,
    uploadMarksCsv,
    getSupervisorlist,
    requestForLockUnlockStatus,
    getSupervisorlistByExamIdSubjectId
} from "../../actions/postExaminationProcessObjectiveActions";

import { getYearList, getAdvertisementlistByYear, downloadSampleCSVFile } from "../../../common/actions/commonActions";
import { useRef } from 'react';
import { parseJSON } from 'date-fns';


// import { uploadVenueCsv, resetVenueErrorList } from '../actions/venueManagementAction';

const ImportMarkCSV = (props) => {
    const { register, errors, reset } = useForm({
        mode: "onChange"
    });

    let [file, setFile] = useState("");


    const dispatch = useDispatch();
    let { examList, advertisementList, subjectList, supervisorListById, getAnswerKeyData, allUnapprovalEntityList, unapprovalPageNoCounter, examinersAndModeratorReportData } = useSelector(
        (state) => state.postExamProcessObjectReducer,
        shallowEqual
    );

    let { yearList, allYearList } = useSelector(
        (state) => state.common,
        shallowEqual
    );
    const fileInputRef = useRef(null);

    const [csvHeader, setCsvHeader] = useState([]);
    const [reloadItem, setReloadItem] = useState(0);
    const [csvErr, setCsvErr] = useState("");
    const [saveButtonFlag, setSaveButtonFlag] = useState(false);

    const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
    const [selectedExam, setSelectedExam] = useState("");
    const [selectedSubject, setSelectedSubject] = useState("");
    const [selectedSupervisor, setSelectedSupervisor] = useState("")
    const [selectedRole, setSelectedRole] = useState("")
    const [selectedCriteria, setSelectedCriteria] = useState(false);
    const [lockStatus, setLockStatus] = useState(false);

    const session = JSON.parse(sessionStorage.getItem("session"));

    useEffect(() => {

    }, [reloadItem]);

    const onAdvertisementChange = (ele) => {
        let selectedValue = ele;
        setSelectedAdvertNo(selectedValue);
        examList.length = 0;
        subjectList.length = 0;
        supervisorListById.length = 0;
        setSelectedExam("");
        setSelectedSubject("");
        setSelectedSupervisor("");
        setFile("");
        setSaveButtonFlag(true);
        selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
        setReloadItem(!reloadItem);
    };

    const onExamChange = (ele) => {
        let selectedValue = ele;
        subjectList.length = 0;
        supervisorListById.length = 0;
        setSelectedExam(selectedValue);
        setSelectedSubject("");
        setSelectedSupervisor("");
        setFile("");
        setSaveButtonFlag(true);
        selectedValue && dispatch(getSubjectlistByExamId(selectedValue));
        setReloadItem(!reloadItem);
    };

    const onSubjectChange = (ele) => {
        let selectedValue = ele;
        supervisorListById.length = 0;
        setSelectedSubject(selectedValue);
        setSelectedSupervisor("");
        setFile("");
        setSaveButtonFlag(false);
        selectedValue && dispatch(getSupervisorlistByExamIdSubjectId(selectedExam, selectedValue));
        // onSubmit(selectedValue);
        setReloadItem(!reloadItem);
        // setEditedValues({});
    };

    const onSupervisorChange = (ele) => {
        let selectedValue = ele.target.value;
        setSelectedSupervisor(selectedValue);
        if (supervisorListById &&
            supervisorListById.length > 0) {
            let selectedSupervisor = supervisorListById.find((ele) => ele.userId == selectedValue);
            setSelectedRole(selectedSupervisor.role);
        }
        setSaveButtonFlag(false);
        // onSubmit(selectedValue);
        setReloadItem(!reloadItem);
        // setEditedValues({});
    };

    const reload = () => {
        setReloadItem((item) => item + 1);
    }
    const onChangeImage = (event) => {
        setCsvErr("");
        if (event.target.files.length == 0) {
            return
        }
        setFile(event.target.files[0])
    }

    const onButtonLockUnlock = (lockStatus) => {
        dispatch(requestForLockUnlockStatus(selectedExam, selectedSubject, selectedSupervisor, lockStatus, cancelModal));
    };

    const handleSampleDownload = (type) => {
        if (selectedRole == "examiner") {
            dispatch(downloadSampleCSVFile("examinerMark"))
        } else if (selectedRole == "moderator") {
            dispatch(downloadSampleCSVFile("moderatorMark"))
        } else if (selectedRole == "chiefmoderator") {
            dispatch(downloadSampleCSVFile("chiefModeratorMark"));
        }
    }

    const uploadFile = () => {
        let data = {};
        data.file = file;
        data.action = 'upload';
        data.selectedCriteria = selectedCriteria;
        if (data.file !== "") {
            setCsvErr("");
            dispatch(uploadMarksCsv(data, selectedExam, selectedSubject, selectedSupervisor, cancelModal, props.onCancelButton, selectedRole));
            setSaveButtonFlag(true);
        } else {
            setCsvErr("This field is required");
        }
    }

    const cancelModal = () => {
        // dispatch(resetVenueErrorList());
        props.setShowImportMarks(false)
        setSaveButtonFlag(false)
        setFile("")
        setCsvErr("")
    }

    const handleInputClick = () => {
        if (file !== "") {
            setSaveButtonFlag(true)
        }
    }

    const jsonToCsv = (error) => {
        const csvRows = [];

        const headers = Object.keys(error[0].venue);
        setCsvHeader(headers);
        csvRows.push(headers.join(','))
        for (let i = 0; i < error.length; i++) {
            for (const row of Object.values(error[i])) {

                const values = headers.map(header => {
                    const escaped = ('' + row[header]).replace(/"/g, '\\"')
                    return `"${escaped}"`
                });
                csvRows.push(values.join(','))
            }
        }
        reload();
        return csvRows.join('\n');

    }

    const downloadFile = (error) => {

        const a = document.createElement('a');
        a.setAttribute("href", "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(error));

        a.setAttribute('hidden', '')

        a.setAttribute('download', 'download.csv')
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
    }

    const onSelectYear = (ele) => {
        let selectedValue = ele;
        selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
        if (allYearList) {
            allYearList.length = 0
        }
        if (examList) {
            examList.length = 0;
        }
        if (subjectList) {
            subjectList.length = 0
        }
        if (supervisorListById) {
            supervisorListById.length = 0
        }
        setSelectedSupervisor("")
        setCsvErr("");
        setFile("");
        reset();
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        setSaveButtonFlag(true);

        setReloadItem(!reloadItem);
    };

    return (
        <div>

            <Modal size="xl" show={props.showImportMarks} onHide={cancelModal} aria-labelledby="example-modal-sizes-title-lg" backdrop='static' >
                <Modal.Header closeButton>
                    <Modal.Title>Import Marks CSV File</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <ul className="nav nav-tabs" role="tablist">
                            <div className="row">
                                <div className="form-group col-md-2">
                                    <label className="float-left">
                                        {commonLabels.selectYear}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedYear"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onSelectYear(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {yearList &&
                                            yearList.length > 0 &&
                                            yearList
                                                .map((element, index) => (
                                                    <option>{element}</option>
                                                ))}
                                    </select>
                                    {_.get("selectedYear.type", errors) ===
                                        "required" && (
                                            <p className="errorText float-left">
                                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                                            </p>
                                        )}
                                </div>
                                <div className="form-group col-md-3">
                                    <label className="float-left">
                                        {commonLabels.SelectAdvertNo}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedAdvertiseNo"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onAdvertisementChange(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {allYearList &&
                                            allYearList.length > 0 &&
                                            allYearList
                                                .filter(
                                                    (element) =>
                                                        element.isDeleted == false &&
                                                        element.isActive === true
                                                )
                                                .map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                                    </option>
                                                ))}
                                    </select>
                                    {_.get("selectedAdvertiseNo.type", errors) ===
                                        "required" && (
                                            <p className="errorText float-left">
                                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                                            </p>
                                        )}
                                </div>

                                <div className="form-group col-md-2">
                                    <label className="float-left">
                                        {label.SelectExam}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedExam"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onExamChange(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="" >
                                            {commonLabels.COMBO_SELECT}
                                        </option>

                                        {
                                            examList &&
                                            examList.length > 0 &&
                                            examList
                                                .filter(
                                                    (element) =>
                                                        element.isDeleted == false &&
                                                        element.isActive === true
                                                )
                                                .map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.name}
                                                    </option>
                                                ))
                                        }
                                    </select>
                                    {_.get("selectedExam.type", errors) === "required" && (
                                        <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>

                                <div className="form-group col-md-2">
                                    <label className="float-left">
                                        {label.SelectSubject}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedSubject"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onSubjectChange(e.target.value);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {
                                            subjectList &&
                                            subjectList.length > 0 &&
                                            subjectList
                                                .map((element, index) => (
                                                    <option key={index} value={element.id}>
                                                        {element.name}({element.type?.toUpperCase()})
                                                    </option>
                                                ))
                                        }
                                    </select>
                                    {_.get("selectedSubject.type", errors) === "required" && (
                                        <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>
                                <div className="form-group col-md-3">
                                    <label className="float-left">
                                        {label.SelectSupervisor}
                                        <span className="errorText">*</span>
                                    </label>
                                    <select
                                        className="form-control"
                                        name="selectedSupervisor"
                                        ref={register({ required: true })}
                                        onChange={(e) => {
                                            onSupervisorChange(e);
                                        }}
                                    >
                                        <option key={0} value="">
                                            {commonLabels.COMBO_SELECT}
                                        </option>
                                        {
                                            supervisorListById &&
                                            supervisorListById.length > 0 &&
                                            supervisorListById
                                                .map((element, index) => {
                                                    if (session.roleName === 'superadmin') {
                                                        return (
                                                            <option key={index} value={element.userId}>
                                                                {element.role}
                                                            </option>
                                                        )
                                                    } else if (session.roleName.toLowerCase() === element.role.toLowerCase()) {
                                                        return (
                                                            <option key={index} value={element.userId}>
                                                                {element.role}
                                                            </option>
                                                        )
                                                    } else {
                                                        return (
                                                            <option key={index} value={element.userId}>
                                                                {element.role}
                                                            </option>
                                                        )
                                                    }
                                                    // eslint-disable-next-line no-unreachable
                                                    return null;
                                                })
                                        }
                                    </select>
                                    {_.get("selectedSupervisor.type", errors) === "required" && (
                                        <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                        </p>
                                    )}
                                </div>

                            </div>
                            <div className="row ml-1 align-items-center">

                                <input
                                    name="fileInput"
                                    type="file"
                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                    onChange={(event) => onChangeImage(event)}
                                    onClick={handleInputClick}
                                    ref={(e) => {
                                        register({ required: true })(e);
                                        fileInputRef.current = e;
                                    }}
                                />

                                {csvErr !== "" && <p className="errorText ml-2 mb-0">{csvErr}</p>}

                                <button
                                    type="button"
                                    onClick={uploadFile}
                                    className="btn btn-primary ml-2"
                                    disabled={
                                        selectedExam === '' ||
                                        selectedSubject === '' ||
                                        selectedSupervisor === '' ||
                                        file === ''
                                    }
                                >
                                    {commonLabels.Update}
                                </button>

                                <div className="ml-2">
                                    <i
                                        className="fa fa-file-excel-o fa-2x text-success"
                                        aria-hidden="true"
                                        onClick={() => handleSampleDownload(selectedSupervisor)}
                                        style={{
                                            cursor: selectedSupervisor === "" ? "not-allowed" : "pointer",
                                        }}
                                        title={
                                            selectedSupervisor === ""
                                                ? label.SELECTTYPE
                                                : label.DOWNLOADTEMPLATE
                                        }
                                    ></i>
                                </div>

                            </div>
                        </ul>
                        <div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={cancelModal} >Cancel</button>
                    {/* <button type="button" className="btn btn-primary" disabled={!saveButtonFlag} onClick={saveFileList}>Save</button> */}
                </Modal.Footer>

            </Modal>

        </div>
    )
}
export default ImportMarkCSV;